import React from "react";
import TextField from "@mui/material/TextField";
import './textfield.css';
const AtomTextField = (props) => {
  const {
    variant = "outlined",
    onChange = () => {},
    label = "",
    error = false,
    size = "medium",
    name,
    value = "",
    ...restProps
  } = props;

  const [randomKey, setRandomKey] = React.useState("")
  const handleStateChange = (e) => {
    onChange({ name, value: e.target.value });
  };

  React.useState(()=>{
    setRandomKey(Math.random())
  },[value,randomKey])
  return (
    <div>
      <TextField
        variant={variant}
        error={error}
        className="input-tag"
        InputProps={{
          sx:{
            height:"40px"
          }
        }}
        label={label}
        onChange={handleStateChange}
        size={size}
        value={value}
        {...restProps}
      />
    </div>
  );
};

export default AtomTextField;
